import React from "react";
import StoreConainer from "features/store/containers/StoreContainer";
function Store() {
  return <StoreConainer />;
}

export default Store;
